// @flow
import { connect } from 'react-redux';
import type { State } from '../../../../../types';
import { makeUserEntitySelector } from '../../../../../selectors/usersSelectors';
import SourceItem from '../SourceItem';
import type { Props } from '../SourceItem';

type OwnProps = $ReadOnly<{
    userId: string
}>;

const mapStateToProps = (state: State, props: OwnProps) => {
    return {
        user: makeUserEntitySelector(props.userId)(state)
    };
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(SourceItem);